<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row>
      <b-col>
        <span :class="`size-${ButtonSize}`">Masalar</span>
      </b-col>

      <b-col class="text-right mb-3 top-buttons">
        <b-btn class="m-1" type="button" variant="danger" to="/Settings" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth >= 340">Ayarlar</span>
        </b-btn>

        <b-btn to="/Settings/Tables/Add" class="btn-info m-1" :size="ButtonSize">
          <i class="material-icons mifix">add</i>
          <span class="ml-1">Masa Ekle</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-table
      striped
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items="Tables"
      :fields="fields"
      responsive
    >
      <template v-slot:cell(PlaceName)="data">
        <div class="ws-nowrap">{{ data.item.PlaceName }}</div>
      </template>

      <template v-slot:cell(Name)="data">
        <div class="ws-nowrap">{{ data.item.Name }}</div>
      </template>

      <template v-slot:cell(Actions)="data">
        <b-btn size="sm" :to="`/Settings/Tables/${data.item.ID}`" class="mr-2">Düzenle</b-btn>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      sortBy: "PlaceName",
      sortDesc: false,
      fields: [
        { key: "PlaceName", label: "Salon Adı", sortable: true },
        { key: "Name", label: "Masa Adı", sortable: true },
        { key: "Sort", label: "Sıralama", sortable: true },
        { key: "Actions", label: "İşlem", sortable: false }
      ]
    };
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    Places() {
      return this.StoreData.Places ? this.StoreData.Places : {};
    },
    Tables() {
      let _Tables = [];

      if (this.StoreData.Tables) {
        for (let i in this.StoreData.Tables) {
          const _Table = this.StoreData.Tables[i];

          if (_Table.PlaceID)
            _Tables.push({
              ID: _Table.ID,
              PlaceName: this.StoreData.Places[_Table.PlaceID].Name,
              Name: _Table.Name,
              Sort: _Table.Sort
            });
        }
      }

      return _Tables;
    }
  },
  mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
